import Repository from "./Repository";
export default {
  getCoinsStats(payload) {
    return Repository.get(
      `/get-transactions?userId=${payload.id}&startDate=${
        payload.startDate || ""
      }&endDate=${payload.endDate || ""}`
    );
  },
  getCoinsDistributionStats() {
    return Repository.get(`/all-configurations`);
  },
};
